import styled from 'styled-components'

export const RedditCardWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  flex: 1 1 0;
  max-width: 33.33%;
  min-width: 0;
  margin-right: 0;
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 900px) {
    max-width: 100%;
    flex-basis: 100%;
  }

  .reddit-orange {
    border-radius: 0 0 8px 8px;
    background-color: #ff5700;
  }

  .post {
    display: flex;
    flex-direction: column;
    height: 100%;

    &-header {
      padding: 4px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-logo {
        img {
          width: 32px;
          height: 32px;
        }
      }

      &-info {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 8px;
      }

      &-profile {
        display: flex;
        align-items: center;

        &-image {
          margin-right: 6px;
          display: flex;
          align-items: center;

          img {
            width: 22px;
            height: 22px;
            border-radius: 50%;
          }
        }

        &-name {
          span {
            font-weight: 500;
            font-size: 13px;
            color: #666;
          }
        }
      }

      &-dot {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #666;
      }

      &-time {
        span {
          font-size: 13px;
          color: #666;
        }
      }
    }

    &-body {
      &-text {
        text-align: start;
        padding: 4px 16px;
        div {
          font-size: 17px;
          color: #333;
          font-weight: 500;
          word-break: break-all;
        }
        button {
          background: none;
          border: none;
          color: #333;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }

      &-media {
        &-image {
          width: 100%;
          max-width: none;
          max-height: 220px;
          display: block;
          margin: 12px auto 0 auto;
          border-radius: 8px;
          object-fit: cover;
        }
      }
    }

    &-footer {
      position: relative;

      &-logo {
        position: absolute;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px;

        &-wrapper {
          padding: 4px;
          border-radius: 100%;
          background: #fff;
          border: 2px solid #333;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      &-info {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px;

        &-like {
          display: flex;
          align-items: center;
          gap: 6px;
          background-color: #dbe4e9;
          padding: 3px 7px;
          border-radius: 1.25rem;
          span {
            font-size: 13px;
            color: #333;
            font-weight: 600;
          }
        }

        &-comments {
          display: flex;
          align-items: center;
          gap: 6px;
          background-color: #dbe4e9;
          padding: 3px 7px;
          border-radius: 1.25rem;
          span {
            font-size: 13px;
            color: #333;
            font-weight: 600;
          }
        }
      }

      &-url {
        text-decoration: none;
        color: #fff;
        font-weight: 600;
        padding: 7px;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;

        a {
          color: #fff;
        }
        a:hover {
          color: #fff;
          text-decoration: underline;
        }
      }
    }
  }

  .fa-Page .post-body-media-image {
    object-fit: unset !important;
    height: auto !important;
  }

  .pdf-image-bg {
    width: 100%;
    height: 180px;
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    margin: 12px auto 0 auto;
  }
`